export async function countStatApi(params) {
  return usePost('/stat/countPie', params);
}
export async function lineStatApi(params) {
  return usePost('/stat/countLine', params);
}